module.exports = __webpack_public_path__ + "img/watermark.c81e43e3.png";